import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { LogFirebase } from "../../../../../services/firestore";
import { setLocalVideotrackPublicationFailed } from "../../../../../reducers/track-failed-reducer";
import { useDispatch } from "react-redux";
import { VideoTrackPublicationFailedModals } from "../../../../CommonModals/VideoTrackFailedModals";
import { ERROR_TYPE } from "../../../../../constants/CallSettingConstants";
import { setAudioError, setAudioErrorModal } from "../../../../../reducers/twilioEvents-reducer";
import { setIsVideoButtonClickDisable } from "../../../../../reducers/common-reducer";

const LocalTrackPublicationFailed = ({ error, track }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (track.kind == "audio") {
            dispatch(setAudioError(ERROR_TYPE.TRACK_PUBLICATION_FAILED));
            dispatch(setAudioErrorModal(true));
        }
        if (track.kind == "video") {
            dispatch(setLocalVideotrackPublicationFailed(true));
            dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
        }
        LogFirebase("TwilioEvents", "trackPublicationFailedFromlocal", {
            track_details: track.kind,
            error_message: error.message,
        });
    }, [error, track]);

    return <>{track.kind == "video" && <VideoTrackPublicationFailedModals />}</>;
};

LocalTrackPublicationFailed.propTypes = {
    track: PropTypes.any,
    error: PropTypes.any,
};

export default LocalTrackPublicationFailed;
